import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-succeeded',
  templateUrl: './billing-succeeded.component.html',
  styleUrls: ['./billing-succeeded.component.scss']
})
export class BillingSucceededComponent implements OnInit {

  isPaymentMethod: boolean = false;

  constructor() {
    
  }

  ngOnInit(): void {
    this.isPaymentMethod = document.location.pathname == '/billing-payment-method-succeeded';
  }

}
